import ListRoute from "./../api/index"
import "../types"

class IndustryUseCase {
    constructor() {
        /** @type {ListRoute}*/
        this.api = new ListRoute()
    }

    /**
     *
     * @param queries
     * @return {Promise<{data, err: null}|{data: *[], err: string}|{data: null, err: *}>}
     */
    async getAll(queries) {
        const {data, err} = await this.api.getAll(queries)
        if (err && err === "record not found") {
            return {data: null, err: null}
        }
        return {data, err}
    }

    async update(id, formData) {
        return await this.api.update(id, formData);
    }
}

export default new IndustryUseCase()